import { FloatingFormItem } from '@/components/_common';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { SendEmailRequest } from '@/core/domain/invoice/invoice/Invoice.types';
import { useSendEmailInvoice } from '@/core/domain/invoice/invoice/invoice.hooks';
import { Modal, Form, Row, Col, Input, Checkbox } from 'antd';

interface Props {
  invoiceId?: number;
  open: boolean;
  onClose: () => void;
}

const MailTecnoSpeedModal = ({ invoiceId, open, onClose }: Props) => {
  const [formSendEmail] = Form.useForm<SendEmailRequest>();

  const sendEmail = useSendEmailInvoice();

  const handleSubimit = async () => {
    const { otherRecipients, ...sendEmailValues } =
      formSendEmail.getFieldsValue();

    await sendEmail.mutateAsync({
      ...sendEmailValues,
      invoiceId: Number(invoiceId),
      otherRecipients: [otherRecipients?.toString()],
    });

    onClose();
  };

  return (
    <>
      {sendEmail.isLoading && (
        <ModalLoadingOverlay
          messages={['Enviando nota...', 'Validando dados da nota...']}
        />
      )}

      <Modal
        title="Enviar Nota Fiscal por e-mail."
        open={open}
        onCancel={onClose}
        onOk={handleSubimit}
        okButtonProps={{ disabled: sendEmail.isLoading }}
        destroyOnClose
        okText="Enviar"
      >
        <Form form={formSendEmail} preserve={false}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <FloatingFormItem label="Enviar para" name="otherRecipients">
                <Input />
              </FloatingFormItem>
            </Col>

            <Col span={24}>
              <FloatingFormItem
                valuePropName="checked"
                name="resendToRecipient"
                initialValue={false}
              >
                <Checkbox>Enviar para o e-mail do destinatário</Checkbox>
              </FloatingFormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default MailTecnoSpeedModal;
